export default "__VITE_ASSET__BZaUP$VF__"